import { render, staticRenderFns } from "./document.vue?vue&type=template&id=84f23dac&scoped=true&"
import script from "./document.ts?vue&type=script&lang=ts&"
export * from "./document.ts?vue&type=script&lang=ts&"
import style0 from "./document.scss?vue&type=style&index=0&id=84f23dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f23dac",
  null
  
)

export default component.exports